const USER_DATA_KEY = 'userData';

export const StorageUtils = {
  /**
   * Save user data to localStorage.
   * @param {Object} data - The user data to save.
   */
  saveUserData: (data) => {
    if (data) {
      localStorage.setItem(USER_DATA_KEY, JSON.stringify(data));
    }
  },

  /**
   * Retrieve user data from localStorage.
   * @returns {Object|null} - The retrieved user data or null if not found.
   */
  getUserData: () => {
    const data = localStorage.getItem(USER_DATA_KEY);
    return data ? JSON.parse(data) : null;
  },

  /**
   * Remove user data from localStorage.
   */
  removeUserData: () => {
    localStorage.removeItem(USER_DATA_KEY);
  },

  /**
   * Clear all user-related cache from localStorage.
   * This includes user data, status, subscription sync data, etc.
   */
  clearAllUserCache: () => {
    // Clear main user data
    localStorage.removeItem(USER_DATA_KEY);
    
    // Clear UserStatusContext cache
    localStorage.removeItem('userStatus');
    localStorage.removeItem('remainingLinks');
    localStorage.removeItem('lastSubscriptionSync');
    localStorage.removeItem('lastStatusUpdate');
    
    // Clear any other user-specific cache
    localStorage.removeItem('darkMode'); // Optional: preserve user preferences
    
    console.log('🧹 All user cache cleared - ready for fresh login');
  },

  /**
   * Save user data and trigger a fresh user status sync.
   * This ensures no cached status data interferes with new user data.
   * @param {Object} data - The user data to save.
   */
  saveUserDataAndRefresh: (data) => {
    if (data) {
      // Clear any existing status cache first
      localStorage.removeItem('userStatus');
      localStorage.removeItem('remainingLinks');
      localStorage.removeItem('lastSubscriptionSync');
      localStorage.removeItem('lastStatusUpdate');
      
      // Save new user data
      localStorage.setItem(USER_DATA_KEY, JSON.stringify(data));
      
      console.log('📋 User data saved with cache refresh');
      
      // Dispatch event to trigger context refresh
      window.dispatchEvent(new CustomEvent('userDataRefresh', { detail: data }));
    }
  },
};
